import React from 'react'

import { SubMenu } from '@application/Types/HeaderTypes'

import { FixedColumnWrapper, SubMenuColumn, SubMenuItem, SubMenuItemDescription, SubMenuItemLink } from './Nav.styled'

export const TwoColumnSubMenu = ({ id, leftLinks, rightLinks }: SubMenu): JSX.Element => {
    return (
        <FixedColumnWrapper>
            <SubMenuColumn>
                {leftLinks?.map((link, index) => (
                    <SubMenuItem key={`${id}-${index}-${link.label}`}>
                        <SubMenuItemLink to={link.link}>{link.label}</SubMenuItemLink>
                        <SubMenuItemDescription>{link.description?.data?.description}</SubMenuItemDescription>
                    </SubMenuItem>
                ))}
            </SubMenuColumn>
            <SubMenuColumn>
                {rightLinks?.map((link, index) => (
                    <SubMenuItem key={`${id}-${index}-${link.label}`}>
                        <SubMenuItemLink to={link.link}>{link.label}</SubMenuItemLink>
                        <SubMenuItemDescription>{link.description?.data?.description}</SubMenuItemDescription>
                    </SubMenuItem>
                ))}
            </SubMenuColumn>
        </FixedColumnWrapper>
    )
}
